import { render, staticRenderFns } from "./App.vue?vue&type=template&id=126e15bf&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "../style/index.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./App.vue?vue&type=style&index=1&id=126e15bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126e15bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/xinyu/.jenkins/workspace/vue-Commonality-CMS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('126e15bf')) {
      api.createRecord('126e15bf', component.options)
    } else {
      api.reload('126e15bf', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=126e15bf&scoped=true&", function () {
      api.rerender('126e15bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "oxygen/cms/components/App.vue"
export default component.exports